// extracted by mini-css-extract-plugin
export var cardIcon = "_1c-5";
export var cardIconUnframed = "_1c-9";
export var checkboxCard = "_1c-0";
export var checkboxCardSelected = "_1c-4";
export var disabled = "_1c-2";
export var interactive = "_1c-1";
export var outerBorder = "_1c-3";
export var spacerMedium = "_1c-8";
export var spacerSmall = "_1c-7";
export var spacerXsmall = "_1c-6";